/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {
  production: false,
  DEFAULT_MERCHANT_NO :  '10',
  IMAGE_BASE_URL : 'https://stg-lion.bookcabin.com/in-resources',
  ORDER_IMAGE_ROOT_URL: 'https://stg-lion.bookcabin.com/in-resources',
  ENV_AIRLINE: 'LION'
};
